import { render, staticRenderFns } from "./tabLessThanCarloadBaseUICustom.vue?vue&type=template&id=486cc297&scoped=true&"
import script from "./tabLessThanCarloadBaseUICustom.vue?vue&type=script&lang=js&"
export * from "./tabLessThanCarloadBaseUICustom.vue?vue&type=script&lang=js&"
import style0 from "./tabLessThanCarloadBaseUICustom.vue?vue&type=style&index=0&id=486cc297&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486cc297",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('486cc297')) {
      api.createRecord('486cc297', component.options)
    } else {
      api.reload('486cc297', component.options)
    }
    module.hot.accept("./tabLessThanCarloadBaseUICustom.vue?vue&type=template&id=486cc297&scoped=true&", function () {
      api.rerender('486cc297', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Integrated/components/booking/tabs/tabLessThanCarloadBaseUICustom.vue"
export default component.exports